/* ⚛ REACT */
import { useRef } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";
import { useTour } from "@reactour/tour";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store/index.js";
import { useSelector } from "react-redux/es/hooks/useSelector";     
import { ChangeControlShowCaption } from "../../../../Redux/Actions/index.js";

/* 📁 ASSETS*/
import { Advertencia, Critico, Manutencao, PerdaComunicacao, NonAlarm } from "../../../../Assets/icons/index.js";

/* 🎨 STYLES */
import { CaptionContainer, CaptionButton, CaptionContent, CaptionItem, CaptionCircle, CaptionImg } from "./styles.js";

const Caption = () => {
    const { t } = useTranslation();

    const { isOpen, currentStep } = useTour();

    const showCaption = useSelector(state => state.controlReducer.showCaption);

    const captionRef = useRef(null);

    return (
        <CaptionContainer>
            <CaptionButton id="caption-button" $showCaption={showCaption} onClick={() => store.dispatch(ChangeControlShowCaption(!showCaption))} disabled={isOpen && currentStep === 1}>
                {t("control.caption.label")}
            </CaptionButton>
            <CaptionContent id="caption" $showCaption={showCaption} $top={captionRef?.current?.getBoundingClientRect()}>
                <CaptionItem>
                    <strong>
                        {t("control.caption.variable.label")}
                    </strong>
                    <CaptionImg src={Critico}/>
                    {t("control.caption.variable.critical")}
                    <CaptionImg src={Advertencia}/>
                    {t("control.caption.variable.warning")}
                    <CaptionImg src={NonAlarm}/>
                    {t("control.caption.variable.alarm")}
                </CaptionItem>
                <CaptionItem>
                    <strong>
                        {t("control.caption.equipment.label")}
                    </strong>
                    <CaptionImg src={PerdaComunicacao}/>
                    {t("control.caption.equipment.communication-loss")}
                    <CaptionImg src={Manutencao}/>
                    {t("control.caption.equipment.maintenance")}
                </CaptionItem>
                <CaptionItem>
                    <strong>
                        {t("control.caption.mode.label")}
                    </strong>
                    <CaptionCircle $background={'#3C3'}>M</CaptionCircle>
                    {t("control.caption.mode.manual")}
                    <CaptionCircle $background={'#3C3'}>A</CaptionCircle>
                    {t("control.caption.mode.automatic")}
                    <CaptionCircle $background={'#3C3'}>S</CaptionCircle>
                    {t("control.caption.mode.smart")}
                </CaptionItem>
                <CaptionItem>
                    <CaptionCircle $background={'#3C3'}>L</CaptionCircle>
                    {t("control.caption.mode.on")}
                    <CaptionCircle $background={'#FF3939'}>D</CaptionCircle>
                    {t("control.caption.mode.off")}
                </CaptionItem>
            </CaptionContent>
        </CaptionContainer>
    );
};

export default Caption;

